module.exports = __webpack_public_path__ + "static/mimic-2d295d0efa66e170c9ed09e9df2c545d.jpeg";